import { notification } from 'antd'

export const openNotificationWithIcon = args => {
  notification.open(args)
}
